import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommunitiesService} from "../_services/communities.service";
import {ThemeService} from "../_services/theme.service";
import {User} from "../_types/user";
import {AuthService} from "../_services/auth.service";
import {SocketService} from "../_services/socket.service";
import {Subscription} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ContentService} from "../_services/content.service";
import {Community} from "../_types/communities";

@Component({
    selector: 'app-authview',
    templateUrl: './authview.component.html',
    styleUrls: ['./authview.component.scss'],
})

export class AuthviewComponent implements OnInit, OnDestroy {
    backgroundImage: string = '';
    user: User | null = null;
    private subscription?: Subscription;
    community: Community | null = null;

    constructor(private communitiesService: CommunitiesService,
                private socketService: SocketService,
                private themeService: ThemeService,
                private contentService: ContentService,
                private authService: AuthService,) {
        this.user = this.authService.getUser();
        if (!this.authService.isLoggedIn()) {
            this.authService.logout();
        }

        this.communitiesService.backgroundImageChange.subscribe((value: string): void => {
            this.backgroundImage = value;
        });

        this.themeService.updateCurrentBrightnessTheme();
        this.contentService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.community = community;
            });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    ngOnInit(): void {
        if (this.user?.id) {
            this.socketService.identify(this.user.id, this.user.username);
            this.subscription = this.socketService.listenToEvents().subscribe((data): void => {
                let reply = data;
                if (Array.isArray(data) && data.length > 0) {
                    reply = data[0];
                }
                if (typeof reply === 'object' && reply.type) {
                    switch (reply.type) {
                        case 'notification':
                            if (reply.object.community && reply.object.community == this.community?.id) {
                                this.socketService.setNewNotification(reply.object.content);
                            }
                            break;
                        case 'points-received':
                            if (reply.object.community_name && reply.object.community_name == this.community?.name) {
                                this.socketService.setNewPoints(reply.object.content);
                            }
                            break
                        case 'badge-earned':
                            if (reply.object.community_name && reply.object.community_name == this.community?.name) {
                                this.socketService.setNewBadge(reply.object.content);
                            }
                            break;
                    }
                }
            }, e => {
                console.error(e);
            });
        }
    }
}
